module.exports = __webpack_public_path__ + "static/media/blackcollection.cee3b055.svg";